import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IrregularidadeOperacaoGarantida } from "src/app/model/operacao-irregular.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class IrregularidadeService extends FgiBackEndService<IrregularidadeOperacaoGarantida>{
    getNewEntity(): IrregularidadeOperacaoGarantida {
        const model = new IrregularidadeOperacaoGarantida();
        return model;
    }    

    protected getResourceURL(): string {
        return 'front/irregularidade';
    }

    getIrregularidades(params?: any):any{
        let options: any = blockUi();
        options.params = params;   
        return this.http.get(`${this.BASE_URL}`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<IrregularidadeOperacaoGarantida>>;
    }
   
    save(entity: IrregularidadeOperacaoGarantida): Observable<IrregularidadeOperacaoGarantida> {
        
        return this.http.post(`${this.BASE_URL}/${ (entity.id) ? 'atualizar/'+entity.id : 'incluir'}`, entity).pipe(
            map(response => this.convertToType(response)),
            catchError((e) => this.handleError(e))) as Observable<IrregularidadeOperacaoGarantida>;
    }      
    
}